import React, { useEffect, useState } from 'react';
import { Card, Rate, Skeleton, Typography } from 'antd';
import './GoogleReviews.css'

const { Paragraph } = Typography;

const GoogleReviews = ({ companyName, companyAddress }) => {
    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState([]);
    const [generalRating, setGeneralRating] = useState("")
    const [totalRatings, setTotalRatings] = useState("")
    const [placeID, setPlaceID] = useState("")
    const [error, setError] = useState(null);

    const getReviews = async () => {
        if (!companyName || !companyAddress) {
            setLoading(false);
            return;
        }

        try {
            const response = await fetch("/los/getGoogleReviews", {
                method: 'POST',
                body: JSON.stringify({
                    companyName,
                    companyAddress
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();
            
            await new Promise(resolve => {
                setReviews(data?.result?.reviews.sort((a, b) => new Date(b.time) - new Date(a.time)) || []);
                setGeneralRating(data.result.rating)
                setTotalRatings(data.result.user_ratings_total)
                setPlaceID(data.result.place_id)
                setLoading(false);
                resolve();
            });
            
        } catch (error) {
            console.error("Error:", error);
            setError(error.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        getReviews();
    }, [companyName, companyAddress]);

    if (error) {
        return <></>
    } else {
        return (
            <div className="google-reviews-section">
                {loading ? (
                    <div>
                        <Skeleton active/>
                        <Skeleton active/>
                        <Skeleton active/>
                    </div>
                ) : reviews?.length > 0 ? (
                    <>
                        <div className="d-flex align-items-center">
                            <img className='mr-2' src="/images/google.svg" alt="GoogleLogo"/>
                            <div className="d-flex align-items-center mr-2">
                                <div className='mr-2' style={{fontSize:"18px", fontWeight:"500"}}>{parseInt(generalRating).toFixed(1)}</div>
                                <Rate disabled defaultValue={generalRating} />
                            </div>
                            <a
                                style={{fontSize:"18px", color:"#325CEB"}}
                                href={`https://search.google.com/local/reviews?placeid=${placeID}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {totalRatings} reviews
                            </a>
                        </div>
                        <div className="google-reviews-container">
                            {reviews
                            .filter(review => review.rating === 5)   
                            .map((review, index) => (
                                <Card key={index} className="google-review-card">
                                    <div className="google-review-header">
                                        <div className="google-reviewer-info">
                                            <img 
                                                src={review.profile_photo_url} 
                                                alt={review.author_name}
                                                className="google-reviewer-photo"
                                                onError={(e) => {
                                                    e.target.src = '/images/avatar.png';
                                                }}
                                            />
                                            <span className="google-reviewer-name">{review.author_name}</span>
                                        </div>
                                        <Rate disabled defaultValue={review.rating} />
                                    </div>
                                    <Paragraph 
                                        ellipsis={{ 
                                            rows: 4,
                                            expandable: true,
                                            collapsible: true,
                                            symbol: 'Read more',
                                            collapseText: 'Show less',
                                            cssEllipsis: true,
                                        }}
                                        className="google-review-text"
                                    >
                                        {review.text}
                                    </Paragraph>
                                    <small className="google-review-time">
                                        {new Date(review.time * 1000).toLocaleDateString()}
                                    </small>
                                </Card>
                            ))}
                            <div className="see-more-reviews">
                                {
                                    companyName.includes("Googain") &&
                                    <a
                                        style={{marginRight:"20px"}}
                                        href={`https://g.page/r/CUtj7cdZ_lAQEB0/review`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Write a review
                                    </a>
                                }
                                <a 
                                    href={`https://search.google.com/local/reviews?placeid=${placeID}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    See more reviews
                                </a>
                            </div>
                        </div>
                    </>
                ) : (
                    <div>No reviews available </div>
                )}
            </div>
        );
    }
};

export default GoogleReviews;